import React from 'react';
import { ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const SessionExpired = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 flex items-center justify-center px-4 py-12">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-amber-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
      </div>

      <div className="relative max-w-lg w-full">
        <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12 border border-gray-100 text-center">

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
              <ClockIcon className="w-10 h-10 text-amber-600" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            Interview Link Expired
          </h1>
          <p className="text-gray-600 text-base sm:text-lg mb-8 leading-relaxed">
            This interview session is no longer active. The link may have expired
            or the session has already been completed.
          </p>

          {/* What to do */}
          <div className="bg-amber-50 rounded-2xl p-6 text-left border border-amber-100 mb-8">
            <h2 className="text-sm font-semibold text-amber-900 mb-3">What you can do:</h2>
            <ul className="space-y-2 text-sm text-amber-800">
              <li className="flex items-start space-x-2">
                <span className="mt-0.5 text-amber-500">•</span>
                <span>Contact the recruiter or hiring manager who sent you this link</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="mt-0.5 text-amber-500">•</span>
                <span>Ask them to send a new interview invitation</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="mt-0.5 text-amber-500">•</span>
                <span>Check your email for any updated links</span>
              </li>
            </ul>
          </div>

          {/* Contact support */}
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
            <EnvelopeIcon className="w-4 h-4 flex-shrink-0" />
            <span>
              Need help?{' '}
              <a
                href="mailto:support@teamsyncai.com"
                className="text-indigo-600 hover:text-indigo-700 font-medium underline"
              >
                support@teamsyncai.com
              </a>
            </span>
          </div>
        </div>

        {/* Footer Branding */}
        <div className="text-center mt-6 text-sm text-gray-500">
          Powered by <span className="font-semibold text-indigo-600">TeamSyncAI</span>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
